// import { MUICalendarView } from "mio-uikit";
import { MCDateGetDateString, NSDateFromString } from "mio-core";
import { UILabel, UISegmentedControl, UIControl, UIView, UIApplication } from "uikit";
import { UITextField } from "uikit";
import { UIViewController } from "uikit";
import { DLDB } from "dldb";
import { MUIDatePicker } from "muikit";
import { StepView, BookingStep } from "./StepView";
import { AppDelegate } from "../AppDelegate";
import { BookingPaxNoticeViewController } from "./BookingPaxNoticeViewController";

export interface BookingCalendarProtocolDelegate
{
    onCalendarDidChange  ( vc: BookingCalendarViewController, date:string ) : void ;
    onNumPeopleDidChange ( vc: BookingCalendarViewController, numberOfPeople:number ) : void ;
}

export class BookingCalendarViewController extends UIViewController implements BookingStep
{
    delegate : BookingCalendarProtocolDelegate = null ;
    
    stepView: StepView;

    private paxSegmentedControl : UISegmentedControl;
    private paxTextField        : UITextField;
    private errorPeopleLabel    : UILabel;
    private calendarView        : MUIDatePicker;
    private errorDateLabel      : UILabel;
    

    numPeople      : number       = -1 ;
    date           : string       = null ;
    availableDays  : number       = 0 ;
    isLoadingDays  : boolean      = false ;
    errors         : string[]     = [] ;
    
    private hasStarted : boolean  = false ;
    

    viewDidLoad ( )
    {
        if (this.paxSegmentedControl)
          this.paxSegmentedControl.addTarget( this, this.onNumPeopleChange, UIControl.Event.valueChanged );

        if (this.paxTextField) {
          this.paxTextField.setOnChangeText( this, this.onNumPeopleChange );
          this.paxTextField.placeholderText = "+9";
        }

        this.calendarView.date = new Date();
        this.calendarView.addTarget( this, this.onDateChange, UIControl.Event.valueChanged );

        this.request_available_days( ) ;
        this.setErrors( [] ) ;
    }

    setNumPeople ( numberOfPeople: number )
    {
        this.numPeople = numberOfPeople;
        this.paxSegmentedControl?.selectSegmentedAtIndex( numberOfPeople - 1 );
        if (this.paxTextField) this.paxTextField.text = numberOfPeople.toString();

        this.clearError( "people" ) ;
        this.request_available_days( ) ;
    }
 
    private onNumPeopleChange ( control: UIControl )
    {
        if ( control instanceof UISegmentedControl ) {
            this.numPeople = control.selectedSegmentIndex + 1;
            if (this.paxTextField) this.paxTextField.text = "";
        }
        else if ( control instanceof UITextField ) {
            this.numPeople = parseInt( control.text, 10 );
            this.paxSegmentedControl.selectSegmentedAtIndex( -1 );
        }

        // Check maxPax and show NOTICE if over, reset number of people to -1
        const maxPax = DLDB.shared.maxPax;
        if (maxPax && this.numPeople > maxPax) {
            this.numPeople = -1;      
            this.paxSegmentedControl?.selectSegmentedAtIndex(-1);
            if (this.paxTextField) this.paxTextField.text = "";
            this.delegate?.onNumPeopleDidChange( this, -1 )
            this.showMaxPaxNotice(maxPax);
            return;
        }
        
        this.clearError( "people" ) ;
        DLDB.shared.cart().pax = this.numPeople > 0 ? this.numPeople : null;
        this.delegate?.onNumPeopleDidChange( this, this.numPeople ) ;
        this.request_available_days( ) ;
    }

    private showMaxPaxNotice(maxPax:number) {
        let vc = new BookingPaxNoticeViewController;
        vc.initWithNibName( "BookingPaxNoticeView" );
        vc.maxPax = maxPax;
        this.presentViewController(vc, true);
    }

    onDateChange ( datePicker: MUIDatePicker ) 
    {
      const date_str = MCDateGetDateString( datePicker.date )
      this.set_date( date_str ) ;

      this.request_available_days( date_str ) ;
    }

    compute_avaiable_days ( )
    {
      const month_date = new Date( ) ;
      month_date.setHours(0);
      month_date.setMinutes(0);
      month_date.setSeconds(0);
      month_date.setMilliseconds(0);
      let today = new Date(); 

      for ( let i = -1 ; ++ i < 31 ; )
      {
        month_date.setDate( i + 1 ) ;

        if ( month_date >= today )
          this.available_days |= 1 << i ;
      }
    }

    private is_loading_days = false ;
    private available_days = 0;
    private has_started = false;

    request_available_days ( date_str?: string )
    {
      const dldb = DLDB.shared;              
      const request_date = date_str || this.date || MCDateGetDateString( this.calendarView.date ) ;

      this.is_loading_days = true ;
      this.available_days = 0 ;
      //   this.calendarView.reloadData( ) ;

      dldb.bookingAvailableDays( request_date, (code,res) =>
      {
        this.is_loading_days = false ;

        if ( code === 200 && !res.error )
        {
            this.available_days = res.data.days ;
            this.calendarView.reloadData( ) ;
            if (this.date) this.calendarView.selectDate( NSDateFromString( this.date ) ) ;
        }
        else
        {
          console.error( "SERVER ANSWER", code, res ) ;
          alert( "Error while checking available days with the server" ) ;
        }
      } ) ;
    }

    canSelectDate ( calendarView: MUIDatePicker, date: Date )
    {
        const day_month_mask = (1<< (date.getDate( ) - 1)) ;
        return ( this.available_days & day_month_mask ) !== 0 ;
    }

    public clear() {

      this.numPeople = -1;      
      this.set_date( null );
      this.calendarView.resetSelection();
      this.paxSegmentedControl?.selectSegmentedAtIndex(-1);
      if (this.paxTextField) this.paxTextField.text = "";

      this.setErrors( [] );

    }

    set_date ( date: string )
    {
      this.date = date ;
      DLDB.shared.cart().date = date ;

      if ( this.delegate ) this.delegate.onCalendarDidChange( this, date ) ;

      this.clearError( "date" ) ;
    }

    check ( )
    {
      const checkIsValid = ( field: string, valid: boolean ) =>
      {
        if ( !valid )
              this.errors.push( field ) ;

        return valid ;
      } ;

      const min_date = new Date( MCDateGetDateString( new Date( ) ) ) ;
      const ret = [ checkIsValid( "date"  , this.date !== "" && (new Date( this.date ).getTime( ) >= min_date.getTime( )) )
                  , checkIsValid( "people", this.numPeople > 0 )
                  ].reduce( (acc,valid) => acc && valid, true ) ;

      if ( !(UIApplication.shared.delegate as AppDelegate).dryRunCheck )this.setErrors( this.errors ) ;

      return ret ;
    }

    // Date picked, plus this step's own pax when the layout puts the people selector here
    hasValue ( ) : boolean {
        const paxHere = this.paxSegmentedControl != null || this.paxTextField != null;
        return this.date != null && this.date !== "" && ( !paxHere || this.numPeople > 0 );
    }


    setErrors ( errors: string[] )
    {
        const errorSpec = this.errorSpec( ) ;

        for ( const err in errorSpec )
            this.clearError( err ) ;

        for ( const err of errors )
            if ( err in errorSpec )
                errorSpec[ err ].hidden = false ;
    }

    clearError ( error: string )
    {
        const errorSpec = this.errorSpec( ) ;

        this.errors = this.errors.filter( e => e !== error ) ;

        if ( errorSpec.hasOwnProperty( error ) )
            errorSpec[ error ].hidden = true ;
    } 

    private errorSpec ( )
    {
        let errorSpec = {};
        if ( this.errorDateLabel ) errorSpec["date"] = this.errorDateLabel;
        if ( this.errorPeopleLabel ) errorSpec["people"] = this.errorPeopleLabel;

        return errorSpec;
    }

    public asJSON ( )
    {
      return { "date": this.date }
    }
}